import { Box } from "@mui/material";
import React from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Header from "../components/header";
import MobileBottomTab from "../components/tabs/mobileBottomTab";
import ReferralWidget from "../components/ReferralWidget";
import { checkLogin } from "../utils/functions";
import InstallPrompt from "../components/pwa/InstallPrompt";
import { investorLeads } from "../services/investorLeads";
import { useState, useEffect } from "react";

export default function DashboardLayout(){
    const showBottomTab = checkLogin();
    const navigate = useNavigate();
    const [activeCampaign, setActiveCampaign] = useState([]);
    async function fetchActiveCampaigns(){
        try{
            const res = await investorLeads.activeCampaigns();
            if(res && res.success){
                setActiveCampaign(res.data);
            }
        }catch(error){
            console.error(error);
            setActiveCampaign([]);
        }
    }
    useEffect(() => {
        fetchActiveCampaigns();
    }, []);
    return(
        <Box
        sx={{
            maxWidth:"1920px",
            position:"relative",
            margin:"auto",
            "--mobile-bottom-tab-height": "84px",
        }}
        >
            <Header />
            <Box
                sx={{
                    padding:{xl:"100px",lg:"32px",md:"24px",xs:"16px"},
                    pt:{xl:"94px",lg:"94px",md:"94px",xs:"84px"},
                    pb: showBottomTab ? { xs: "calc(var(--mobile-bottom-tab-height) + env(safe-area-inset-bottom, 0px))", md: 0 } : 0,
                    maxWidth:"1920px"
                }}
            >
                <Outlet />
            </Box>
            {showBottomTab && <MobileBottomTab />}
            <InstallPrompt />
            {showBottomTab && activeCampaign && (
                <ReferralWidget
                    onViewTracking={() => navigate("/referrals")}
                />
            )}
        </Box>
    )
}